import { EventEmitter } from '@angular/core';
import { Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { SelectItem } from 'primeng';
import { NewMessage } from 'src/app/models/message';
import { PromiseResult, ErrorModel, ServerError } from 'src/app/models/PromiseResult';
import { MessagecenterService } from 'src/app/services/messagecenter.service';
import { SendProfileLinkService } from 'src/app/services/send-profile-link.service';
import { roles } from '../../../constant/constant';

@Component({
    selector: 'app-share-message-doctors',
    templateUrl: './share-message-doctors.component.html',
    styleUrls: ['./share-message-doctors.component.css']
})
@TraceClassDecorator()
export class ShareMessageDoctorsComponent implements OnInit {

    @Input("messageString")
    messageString: string = "";
    @Output() dialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onGetLink: EventEmitter<any> = new EventEmitter<any>();

    doctor_list: SelectItem[] = [];
    readonly max_subject_length: number;
    readonly max_message_length: number;
    message: NewMessage;
    message_response: PromiseResult;
    message_error: ErrorModel;
    message_serverError: ServerError = null;
    message_posting: boolean;
    private readonly user: roles;
    doctor_user_id: string;
    profileLinkAdded: boolean = false;
    zoom_link: string = ""
    constructor(
        private readonly doctorMessageService: MessagecenterService,
        private readonly shareLink: SendProfileLinkService) {
        this.max_subject_length = 100;
        this.max_message_length = 500;
        this.message_posting = false;
        this.user = roles.doctor;
        // this.user_type=null;
    }

    async ngOnInit(): Promise<void> {
        this.doctor_user_id = sessionStorage.getItem('userid');
        this.message = {
            patient_guid: null,
            from_user_guid: this.doctor_user_id,
            to_user_guid: [],
            subject: "",
            message: "",
            reply_id: null
        }
        await this.ResetMessageModels();
        this.message_posting = false;
        // await this.GetDoctors();
        if (this.messageString.length > 0) {
            this.message.message = "Zoom Link : \n" + this.messageString;
            this.zoom_link = this.messageString;
        }
    }

    async sendMessage(): Promise<void> {
        // if(this.user_type==user.patient) this.message.to_user_guid=null;
        this.message.patient_guid = null;
        await this.ResetMessageModels();
        this.message_posting = true;
        await this.doctorMessageService.CreateMessage(this.message, this.user).toPromise().then((result: PromiseResult) => {
            this.message_response = result;
            this.message_posting = false;
        }).catch(error => {
            this.message_posting = false;
            this.message_response.success = false;
            this.message_serverError = error.error;
        });
        this.dialogChange.emit(Boolean(this.message_response.success));

    }

    private async ResetMessageModels(): Promise<void> {
        this.message_response = {
            success: null,
            error: null,
            data: null
        };
        this.message_serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }

    getLink() {
        this.shareLink.getProfileLink().subscribe((message) => {
            if (this.zoom_link && message)
                this.message.message = "Zoom Link : \n" + this.zoom_link + "\n\nShare Link \n" + message.toString();
            if (!this.zoom_link && message)
                this.message.message = "Share Link \n" + message.toString();
            if (this.zoom_link && !message)
                this.message.message = "Zoom Link : \n" + this.zoom_link;
            if (!this.zoom_link && !message)
                this.message.message = "";
            if (message)
                this.profileLinkAdded = true;
        });
    }

    onDoctorChange(doctor_guid) {
        this.message.to_user_guid = []
        this.message.to_user_guid.push(doctor_guid);
        this.profileLinkAdded = false;
        if (this.zoom_link)
            this.message.message = "Zoom Link : \n" + this.zoom_link;
        this.shareLink.resetProfileLink();
        this.onGetLink.emit(doctor_guid);

    }

}
